// src/utils/crypto.js
import CryptoJS from "crypto-js";

const secretKey = "wangxiaowenwangweifeng1314"; // 这个密钥应与后端保持一致，使用环境变量或更安全的管理方式

export function encrypt(text) {
  return CryptoJS.AES.encrypt(text, secretKey).toString();
}
